import React from 'react'
import {Route, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {saveLocalState} from "../actions/http"

const LoginRoute = ({user, dispatch, ...restProps}) => {
    if(user.token){
        if(!localStorage.user){
            saveLocalState(user);
        }
        return <Redirect to={process.env.REACT_APP_NAME === 'store' ? "/" : "/book-now"} />
    } 
    return <Route {...restProps}/> 
}

export default connect((state) => ({user: state.loginReducer.data}))(LoginRoute)